import React, { lazy } from 'react';
import { Switch, BrowserRouter as Router } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import env from 'config/env';

function Routes() {
  return (
    <Router basename={env.appUrl}>
      <Switch>
        <PrivateRoute
          exact
          //model="cloud-user-ui"
          path="/"
          component={lazy(() => import('pages/cloud-invoice-ui'))}
        />



      </Switch>

    </Router>
  );
}

export default Routes;
